import ShareableLinkItems from './ShareableLinkItems.component';

export default ShareableLinkItems;
